import React from 'react';
import PropTypes from 'prop-types';
import QAItem from '../QAItem';
import useSearchMatches from '../../hooks/useSearchMatches';
import { QuestionsContainer, NoResults } from './styled';

const Questions = ({ questions, hideAddonLabel, ...props }) => {
  const { isSearchMatch } = useSearchMatches(questions);

  return (
    <QuestionsContainer data-id="term-definition-container" {...props}>
      {isSearchMatch ? (
        questions.map((item, i) => (
          <QAItem
            key={i}
            id={`question-${item.sys?.id}`}
            question={item.fields.question}
            answer={item.fields.answer}
            sections={item.fields?.sections}
            hideAddonLabel={hideAddonLabel}
            isOpen
          />
        ))
      ) : (
        <NoResults>No results found</NoResults>
      )}
    </QuestionsContainer>
  );
};

Questions.propTypes = {
  className: PropTypes.string,
  questions: PropTypes.array,
  hideAddonLabel: PropTypes.bool
};

export default Questions;
